module.exports = __webpack_public_path__ + "e6f1b86a.png";